import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Input, Label } from "rbx";

// import { ProductSelect, SystemCodeSelect } from "../inputs";
import { ProductSelect } from "../inputs";

const RouteProductDispatcherForm = ({ inputs, onChange }) => (
  <div style={{ width: 600, maxWidth: "100%" }}>
    <Field kind="group">
      <Control expanded>
        <ProductSelect
          icon="globe"
          label="Product"
          name="ProductNoRecIdRef"
          value={inputs.ProductNoRecIdRef}
          where={{ ProductCatgRecIdRef: 306 }}
          onChange={onChange}
        />
      </Control>
    </Field>
    {/* <Field>
      <Control>
        <SystemCodeSelect
          name="UOMRecIdRef"
          value={inputs.UOMRecIdRef}
          label="UOM"
          onChange={onChange}
          icon="globe"
          lookup={{ Code: "UOM" }}
        />
      </Control>
    </Field> */}
    <Field>
      <Control>
        <Label>Description</Label>
        <Input
          name="Description"
          type="text"
          value={inputs.Description}
          onChange={onChange}
        />
      </Control>
    </Field>
  </div>
);

RouteProductDispatcherForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func
};

RouteProductDispatcherForm.defaultProps = {};

export default RouteProductDispatcherForm;
